/* DSL Geo-promo — toon andere banners per land */
(function(){
  var country = (document.cookie.match(/__cf_country=([A-Z]{2})/) || [])[1] || (navigator.language || "").split("-")[1] || "NL";
  var BANNERS = {
    NL: "🇳🇱 Gratis verzending NL vanaf €99 — bestel voor 16:00, morgen geleverd.",
    BE: "🇧🇪 Verzending naar BE binnen 3-5 werkdagen — 5% extra korting bij eerste bestelling met code BENL5.",
    DE: "🇩🇪 Versand nach DE 3-5 Werktage — 10% Rabatt bei erster Bestellung mit Code WELCOMEDE.",
    FR: "🇫🇷 Livraison FR 5-7 jours — 10% off avec WELCOMEFR",
    GB: "🇬🇧 Shipping to UK 7-10 days — VAT included."
  };
  var msg = BANNERS[country.toUpperCase()];
  if (!msg) return;
  var bar = document.createElement("div");
  bar.className = "dsl-geo-promo";
  bar.setAttribute("role", "status");
  bar.innerHTML = msg + " <button class=\"dsl-geo-promo__close\" aria-label=\"Sluit\">&times;</button>";
  document.body.insertBefore(bar, document.body.firstChild);
  bar.querySelector(".dsl-geo-promo__close").addEventListener("click", function(){ bar.remove(); });
  if (window.DSL_AB) window.DSL_AB.track("geo_promo_show", {country: country});
})();